import "./style.scss";

// ===========================================================================
// Header
// ===========================================================================
export enum ListHeaderCellType {
  textCell = "listHeader_textCell",
  sentenceCell = "listHeader_sentenceCell",
}

type ListHeaderCellProps = {
  type: ListHeaderCellType;
  label?: string;
};

export const ListHeaderCell = (props: ListHeaderCellProps) => {
  const { type, label } = props;
  return <span className={type}>{label}</span>;
};

// ===========================================================================
// Body
// ===========================================================================
export enum ListBodyCellType {
  // listCategoryLabel =  "listCategory listCategory_label"
  textCell = "listBody_textCell",
  sentenceCell = "listBody_sentenceCell",
  labelCell = "listBody_labelCell",
  nameCell = "listBody_nameCell",
  amountCell = "listBody_amountCell",
  confirmCell = "listBody_confirmCell",
  dateCell = "listBody_dateCell",
  checkCell = "listBody_checkCell",
}

type ListBodyCellProps = {
  type: ListBodyCellType;
  label?: React.ReactNode;
};

export const ListBodyCell = (props: ListBodyCellProps) => {
  const { type, label } = props;
  return <span className={type}>{label}</span>;
};
